import { render } from "./BookAnimation.vue?vue&type=template&id=5e7d8d97"
import script from "./BookAnimation.vue?vue&type=script&lang=js"
export * from "./BookAnimation.vue?vue&type=script&lang=js"

import "./BookAnimation.vue?vue&type=style&index=0&id=5e7d8d97&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__